import { ReceptionSearchActiveKinds } from "../../../../domain/workflow/search";

export class ReceptionSearchActiveKindTranslator {
  public static toReceptionSearchActiveKinds(value: boolean): ReceptionSearchActiveKinds {
    if (value === true) { return ReceptionSearchActiveKinds.Activated; }
    if (value === false) { return ReceptionSearchActiveKinds.Inactivated; }
    return ReceptionSearchActiveKinds.NotSpecificated;
  }

  public static toBoolean(value: ReceptionSearchActiveKinds): boolean {
    if (value === ReceptionSearchActiveKinds.Activated) { return true; }
    if (value === ReceptionSearchActiveKinds.Inactivated) { return false; }
    return null;
  }
}
